import { Injectable } from "@angular/core"
import { FormGroup } from "@angular/forms";

@Injectable({
    providedIn:'root'
})
export class FormValidationErrorService{
  getFormValidationErrors(formGroup:FormGroup, validationMessages:Record<string, Record<string, string>>): string[] {
    const errors: string[] = [];
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control?.errors) {
        Object.keys(control.errors).forEach(errorKey => {
          const message = validationMessages[key]?.[errorKey];
          if (message) errors.push(message);
        });
      }
    });
    return errors;
  }
}